// Show file name after file select.
//
const showFileName = () => {
    $('.custom-file-input').change(function(){
        if (!(this.files && this.files[0])) {
            return;
        }

        const fileName = this.files[0].name;
        $(this).prev('.custom-file-label').html(fileName);
    });
};

// Close the cookie banner.
//
const closeCookieBanner = () => {
    $('#js_closeBanner').on('click', function(e) {
        e.preventDefault();
        $(this).parents('#js_cookieBanner').addClass('d-none');
    });
};

// Shows the tutorial modal.
//
const showTutorialModal = () => {
    $('#tutorial-modal').modal();
};

// Close the Newsletter banner.
//
const closeNewsletterModal = () => {
    let newsletterSelector = $('#js_newsletter');

    newsletterSelector.find('a').on('click', function(e) {
        e.preventDefault();
        newsletterSelector.addClass('d-none');
    });
};

// Show Redox Interactive disclaimer.
//
const showDisclaimer = () => {
    // Don't show in frame preview, since the game itself is already outputting the same disclaimer.
    if ($('#js_iframe').length) {
        return;
    }

    console.log(
        '%c 🕹 by Redox Interactive',
        'color: #21201f; font-size: 14px; font-family:system-ui; background: #f4f4f4; padding: 6px 12px 6px 6px;'
    );
};

export {
    showFileName,
    closeCookieBanner,
    showTutorialModal,
    closeNewsletterModal,
    showDisclaimer
};